module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4AwUDQovmf3aawAAALpJREFUOMvdlKEOgzAURU9HU02CnEBP8g2A41OQGBIQ/BKCkCD4GhQLCjHB0gm2MMOSlpntmOZVnPT2vTxxS1ONCVJy9TzORSFeVydMWRbGtmWoKm0veTJ2HUNZagDJAca+hzzXVpJLEGzFPNvHeeezRClUloFS9hIZRQjfR0aRnUS4Lk4YAuCEIcJ1zSVOkmwxlFpr4zjTxL3rANZzmvZj7w5m06wvimOWuj7Qna+0+Ockwnif/P+fPADLYy4wzqT5YAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/upload-row.png
// module id = 2293
// module chunks = 1